import { EMPTY_SPACE, BLANK } from '@ts-core/utils/Constants';

import { transformCoreFormInputToCoreExerciseInput, transformCoreExerciseToFormInput } from 'modules/exercises/utils';

import { FillInTheBlanksExerciseInput, FillInTheBlanksQuestionInput } from '../types/form';
import {
  FillInTheBlanksExercise,
  FillInTheBlanksQuestion,
  CreateFillInTheBlanksExerciseInput,
  CreateFillInTheBlanksQuestionInput,
  CreateFillInTheBlanksQuestionOptionInput,
} from '../types';

function transformFormQuestionIntoMutationInput(questions: FillInTheBlanksQuestionInput[]): CreateFillInTheBlanksQuestionInput[] {
  return questions.map((question) => {
    const { text, blankIds } = question;
    const chunks = text.split('**');
    const questionText: string[] = [];
    const options: CreateFillInTheBlanksQuestionOptionInput[] = [];
    chunks.forEach((chunk, index) => {
      if (index % 2 === 1) {
        // Blanks are always in odd indexes
        const blankIndex = Math.floor(index / 2);
        options.push({ text: chunk, type: 'positive', _id: blankIds?.[blankIndex] });
        questionText.push(BLANK);
      } else {
        questionText.push(chunk === '' ? EMPTY_SPACE : chunk);
      }
    });

    return {
      _id: question._id,
      text: questionText,
      options,
    };
  });
}

function transformFillInTheBlanksQuestionIntoFormInput(questions: FillInTheBlanksQuestion[]): FillInTheBlanksQuestionInput[] {
  return questions.map((question) => {
    const { text: chunks, options } = question;
    const result: string[] = [];
    const blankIds: string[] = [];
    chunks.forEach((chunk, index) => {
      const blankIndex = Math.floor(index / 2);
      if (chunk === BLANK) {
        const blank = options[blankIndex];
        blankIds.push(blank._id);
        result.push(`**${blank.text}**`);
      } else if (chunk !== EMPTY_SPACE) {
        result.push(chunk);
      }
    });

    return {
      _id: question._id,
      text: result.join(''),
      blankIds,
    };
  });
}

export function getTextFormatError(text: string): string | undefined {
  if (text.length === 0) {
    return undefined;
  }
  const lonelyStarsRegex = /[^*](\*)[^*]/g;
  const lonelyStarsMatches = text.match(lonelyStarsRegex) || [];

  if (lonelyStarsMatches.length > 0) {
    return 'Debes usar ** para rodear la palabra que quieres marcar como espacio a completar.';
  }

  const chunks = text.split('**');
  if (chunks.length % 2 === 0) {
    return 'Todos los espacios tienen que estar rodeados por **.';
  }

  return undefined;
}

export function getPreviewText(text: string): string {
  const regex = /\*\*(.*?)\*\*/gm;
  const preview = text.replace(regex, '________ ($1)');

  if (preview) {
    return preview;
  }
  return text;
}

export function transformFormInputToMutationInput(formInput: FillInTheBlanksExerciseInput): CreateFillInTheBlanksExerciseInput {
  const coreData = transformCoreFormInputToCoreExerciseInput(formInput);
  const { questions } = formInput;
  return {
    ...coreData,
    type: 'FillInTheBlanksExercise',
    questions: transformFormQuestionIntoMutationInput(questions),
  };
}

export function transformFillInTheBlanksExerciseToFormInput(exercise: FillInTheBlanksExercise): FillInTheBlanksExerciseInput {
  const coreData = transformCoreExerciseToFormInput(exercise);
  return {
    ...coreData,
    questions: transformFillInTheBlanksQuestionIntoFormInput(exercise.questions),
  };
}
